import { PostalAddress } from '../../../common/model/postal-address';
import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';
import { InvoiceDeliveryMethod } from '../../../invoice/model/const/enum';
import { RentalObjectCategory } from '../const/enums';
import { TransferType } from '../const/transfer-type';
import { TransferBuyer } from './transfer-buyer';
import { TransferSeller } from './transfer-seller';

export class BrfTransferListItem extends ModelBase {
  companyName: string;
  rentalId: string;
  sellers: string;
  buyers: string;
  transferDate: LocalDate;
  amount: Money;
  transferType: TransferType;
  currencyCode: string;
  additionalPayment_639: Money;
  innerFund_635: Money;
  totalShare: number;
  isLocked: boolean;
  errorMessage: string;
  rentalObjectAddress: string;

  toString() {
    const id = this.rentalId ? this.rentalId : '';
    const date = this.transferDate ? (this.transferDate.hasValue ? new Date(this.transferDate.year, this.transferDate.month - 1, this.transferDate.day).toLocaleDateString(): '') : '';
    return `${id} ${date}`.trim();
  }
}
